module.exports = "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAAA4AAAAPCAYAAADUFP50AAABVUlEQVQ4T62Sv0vDUBDH7xoFh2RK52YR9N8R6aRDrVC0k+a9weik6BDIhdqpiEVRUHRwte7+BYKz0C6OQlOExryTVxKomNoOvunu+H7e/eCLMOOr1WrzlmXdA8A1ET3gLFy5XDYcx7kDgFVmjhFxBYUQy5Pg4XD4Ztt23O/3rxBxLdUlALCOUkrOA5n5vNvtbpVKpTNErKYapZTaDMPwcgQiYksp9ZR9wMxfvV7v0XGcJgDUdZ2ZdYM6EbV0PgKZeTsrZLCUkgDAzXKl1G4Yho0szwWFECeIuD82gWdZVjOKosUgCF5yO0opDwDgeGzvQ9M0jwaDQSdJkhu93y/Q8zw7juN3AJhLQT8Igr1KpbJQLBY/lVIbuaDrutVCodBOj3FKRDs6ngoKIRqIGBmGcev7/ms27lRwkhH+HwQAfZCPP3yrPb304zhCiItZjJ5q2kT0rONvb8/sa6tmxY0AAAAASUVORK5CYII="


//////////////////
// WEBPACK FOOTER
// ./src/assets/edit.png
// module id = 33aG
// module chunks = 1